/* eslint-disable @typescript-eslint/no-explicit-any */
// Imports for external libraries go here.

import React, { useEffect, useState, useRef } from 'react';
import { StyledTab } from './Tabs.styles';
import { Button, Icon, Heading, Types } from '@marriott/mi-ui-library';
import { TabProps } from './Tabs.types';
import { clsx } from 'clsx';
import Glide from '@glidejs/glide';

export const TabConfig = {
  emptyLabel: 'Tab',
  isEmpty: () => true,
  resourceType: `/components/content/Tab`,
};

export const TabComponent = (props: TabProps) => {
  const tabProps = props;
  const { tabList, componentId, trackingProperties, isAuthorMode, styleclass } = tabProps;
  //const componentId = 'qpjlhvyf9g5gqbfu';
  const [activeTab, setActiveTab] = useState(props.setSelectedTab);
  const cardsCount = tabList.length;
  const arrowStyle = styleclass?.includes('standard')
    ? 'stand-arrow'
    : styleclass?.includes('inverse')
    ? 'inv-arrow'
    : '';
  const [cardsPerView, setCardsPerView] = useState(2);
  const [viewPort, setViewPort] = useState('Desktop');
  const [miniTab, setMiniTab] = useState(false);
  const tabPerViewCount = 5;
  const tabActionRef = useRef(null) as unknown as React.MutableRefObject<HTMLAnchorElement>;

  useEffect(() => {
    window.addEventListener('resize', handleResize);
  });

  const handleResize = () => {
    const sm = window.matchMedia('(max-width: 575px)');
    const md = window.matchMedia('(min-width:576px) and (max-width: 767px)');
    //const lg = window.matchMedia('(min-width: 768px)and (max-width: 991px)');
    const lg = window.matchMedia('(min-width: 768px)and (max-width: 1366px)');
    const xl = window.matchMedia('(min-width: 1367px)');
    // As we are considering 768 as mini tablet and showing only 5 tab items.
    // For all other tablet we are sing 7 tab items.
    const xlg = window.matchMedia('(min-width: 576px) and (max-width: 768px)');
    if (sm?.matches) {
      setViewPort('Mobile');
      setCardsPerView(1);
    } else if (md?.matches) {
      setViewPort('Mobile');
      setCardsPerView(1);
    } else if (lg?.matches) {
      setViewPort('Tablet');
      setCardsPerView(1);
    } else if (xl?.matches) {
      setViewPort('Desktop');
      setCardsPerView(3);
    }
    if (xlg?.matches) {
      setMiniTab(true);
    }
  };

  useEffect(() => {
    const pageWcmMode = document.getElementsByTagName('html')[0];
    const updateStyleComponent = document.getElementById(`${componentId}__slides`);
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const currWcmMode = pageWcmMode?.getAttribute('class');
          if (currWcmMode?.includes('Edit')) {
            updateStyleComponent?.classList.add('glide__slides_authoring');
          } else if (currWcmMode?.includes('Preview')) {
            updateStyleComponent?.classList.remove('glide__slides_authoring');
          }
        }
      });
    });
    observer.observe(pageWcmMode, { attributes: true });
    handleResize();

    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // For example, Item 8 (index 7)
  const selectedIndex = tabList?.findIndex(item => activeTab === item?.tabValue);
  useEffect(() => {
    const carouselRootSelector = `#${componentId}`;
    if (document?.querySelector(carouselRootSelector)) {
      try {
        new Glide(carouselRootSelector, {
          type: 'slider',
          bound: true,
          perView: 7,
          startAt:
            activeTab && (viewPort === 'Tablet' || viewPort === 'Mobile')
              ? getVisibleItemsStartIndex(selectedIndex, cardsCount)
              : 0,
          rewind: false,
          gap: 3,
          autoplay: false,
          dragThreshold: false,
          swipeThreshold: false,
          breakpoints: {
            575: {
              perView: 3,
            },

            768: {
              perView: tabPerViewCount,
            },
            1180: {
              perView: 7,
            },
          },
        }).mount({ ArrowDisabler });

        document
          ?.querySelector(`#${componentId}_left_arrow`)
          ?.addEventListener('touchstart', (e: any) => e.preventDefault());
        document
          ?.querySelector(`#${componentId}_right_arrow`)
          ?.addEventListener('touchstart', (e: any) => e.preventDefault());
      } catch (error) {
        // log.error(`Error in initializing Glide for ${componentId}`, error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsPerView, activeTab]);

  const getVisibleItemsStartIndex = (selectedIndex: number, totalItems: number) => {
    // Ensure there are at least min items to display
    const minVisibleItems = miniTab ? 5 : viewPort === 'Tablet' ? 7 : 3;
    const minPreviousItems = miniTab ? 2 : viewPort === 'Tablet' ? 3 : 1;

    let startIndex: number = 0;

    // If the selected item is the last one (index 8, for example)
    if (selectedIndex >= totalItems - minPreviousItems) {
      // Show the last 5 items, starting from index (totalItems - 5)
      startIndex = Math.max(0, totalItems - minVisibleItems);
    } else {
      // Otherwise, center the selected item with 2 items before and 2 items after
      startIndex = Math.max(0, selectedIndex - minPreviousItems);
    }

    return startIndex;
  };

  const ArrowDisabler = function (Glide: any, Components: any) {
    return {
      mount() {
        // Only in effect when rewinding is disabled
        if (Glide.settings.rewind) {
          return;
        }
        const left = document?.querySelector('.glide__arrow--left');
        left?.classList.remove('.is-disabled');
        Glide.on(['mount.after', 'run'], () => {
          // Filter out arrows_control
          for (const controlItem of Components.Controls.items) {
            if (controlItem.className !== 'glide__arrows') {
              continue;
            }

            // Set left arrow state
            const left = controlItem?.querySelector('.glide__arrow--left');
            if (left) {
              if (Glide.index === 0) {
                left.classList.add('.is-disabled'); // Disable on first slide
              } else {
                console.log('glide index', Glide.index);
                left.classList.remove('.is-disabled'); // Enable on other slides
                //const updateStyleComponent = document.getElementById(`${componentId}__slides`);
                //updateStyleComponent?.classList.add('leftMaskedTab');
              }
            }

            // Set right arrow state
            const right = controlItem?.querySelector('.glide__arrow--right');
            if (right) {
              if (viewPort === 'Tablet') {
                if (Glide.index === 0) {
                  if (tabList.length > Glide.settings.perView) {
                    right.classList.remove('.is-disabled');
                  }
                }
                if (Glide.index > 0) {
                  if (Glide.index === tabList.length - Glide.settings.perView) {
                    right.classList.add('.is-disabled'); // Disable on last slide
                  } else {
                    right.classList.remove('.is-disabled'); // Disable on other slides
                  }
                }
                //right.classList.add('.is-disabled');
              } else {
                if (Glide.index === Components.Sizes.length - Glide.settings.perView) {
                  right.classList.add('.is-disabled'); // Disable on last slide
                } else {
                  right.classList.remove('.is-disabled'); // Disable on other slides
                }
              }
            }
          }
        });
      },
    };
  };
  useEffect(() => {
    if (props.setSelectedTab) {
      setActiveTab(props.setSelectedTab);
    }
  }, [props]);

  return (
    <StyledTab
      className={clsx(
        'tab-wrapper',
        ` ${!props.disabledContainerClass && 'container'}`,
        ` ${props.hidetabsAndContent && 'd-none'}`
      )}
    >
      <div id={componentId} className={clsx(`glide 'col-md-8 p-0'}`)}>
        <div className={clsx('glide__track')} data-glide-el="track">
          <ul
            className={clsx(`m-standard-tab-list`, `tabUL`, ``, 'glide__slides', {
              'tabLi-show-all': viewPort === 'Tablet' && !miniTab && cardsCount <= 7,
            })}
            id={`${componentId}__slides`}
          >
            {tabList.map((tab, key) => {
              const { tabTitle, tabValue, tabIcon, tabAction } = tab;

              return (
                <li
                  key={key}
                  className={clsx(
                    'custom_click_track',
                    `m-standard-tab-list-item`,
                    activeTab === tabValue ? 'active' : 'inactive-tab'
                  )}
                  {...{
                    custom_click_track_value: `${tabTitle}-tab`,
                  }}
                  aria-label={tabTitle}
                >
                  <Button
                    isLink={props.isTablink !== undefined ? props.isTablink : true}
                    href={tabAction}
                    ref={tabActionRef}
                    ariaExpanded={tabValue}
                    custom_click_track_value={`${tabTitle}-tab`}
                    trackingProperties={trackingProperties}
                  >
                    <div className={clsx('tabIconText')}>
                      <Icon iconClass={`${tabIcon} iconContainer`} />

                      <Heading
                        element={Types.tags.span}
                        variation={Types.headingType.subtitle}
                        titleText={tabTitle}
                        disableCustomClickTrack={props?.disableCustomClickTrack}
                      />
                    </div>
                  </Button>
                </li>
              );
            })}
          </ul>
        </div>

        {!isAuthorMode &&
          viewPort !== 'Desktop' &&
          ((viewPort === 'Tablet' && !miniTab && cardsCount > 7 && cardsCount !== cardsPerView) ||
            (miniTab && cardsCount > tabPerViewCount && cardsCount !== cardsPerView) ||
            (!miniTab && viewPort === 'Mobile' && cardsCount !== cardsPerView)) && (
            <div className="center-align" data-testid="mobile-tabs">
              <div className={`carouselControlType1 ${arrowStyle} `}>
                <div className="glide__arrows" data-glide-el="controls">
                  <button
                    className={clsx('left-arrow', 'glide__arrow--left', ``)}
                    id={`${componentId}_left_arrow`}
                    data-glide-dir="<"
                    aria-label="left-arrow"
                    data-custom_click_track_value={`internal`}
                  >
                    <span className="icon-arrow-left" id={`${componentId}_left_arrow`} data-id="left"></span>
                  </button>
                </div>
                <div className="glide__arrows" data-glide-el="controls">
                  <button
                    className={clsx('right-arrow', 'glide__arrow--right')}
                    id={`${componentId}_right_arrow`}
                    data-glide-dir=">"
                    aria-label="right-arrow"
                  >
                    <span className="icon-arrow-right" data-id="right"></span>
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
    </StyledTab>
  );
};
